import { ThemeConfig } from 'antd'
import _ from 'lodash'
import themeJSON from './theme.json'

const theme: any = _.merge({}, themeJSON, {
  components: {
    Menu: {
      collapsedWidth: 52,
    },
  },
})

export const EditTheme: ThemeConfig = {
  components: {
    Form: {
      itemMarginBottom: 10,
    },
  },
}

export default theme
